import { useNavigate } from "react-router-dom";
import defaultLogo from "./../../../assets/images/logo/logo.svg";

import "../../../styles/layouts/header/_headerLogoComponent.scss";
import useLogoConfiguration from "../../../hooks/useLogo";

export const HeaderLogoComponent = () => {
  const navigate = useNavigate();
  const { logoUrl, isLoading } = useLogoConfiguration();

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <div className="logoContainer" onClick={handleLogoClick}>
      {!isLoading && <img src={logoUrl || defaultLogo} alt="logo" />}
    </div>
  );
};

export default HeaderLogoComponent;
